import { addDays, endOfDay, format, startOfDay, subDays } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

// Match the initial range and reset behavior of the E-mail reports.
export const getDefaultWhatsAppReportDates = (now = new Date()) => ({
  startDate: format(startOfDay(subDays(now, 15)), "dd/MM/yyyy HH:mm"),
  endDate: format(endOfDay(addDays(now, 15)), "dd/MM/yyyy HH:mm"),
});

export const whatsAppReportTimestamp = (value) => {
  if (!value) return NaN;
  if (value instanceof Date) return value.getTime();
  const text = String(value).trim().replace(" ", "T");
  return new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(text) ? text : `${text}Z`).getTime();
};

export const formatWhatsAppReportDate = (value, timeZone) => {
  const timestamp = whatsAppReportTimestamp(value);
  return Number.isFinite(timestamp) ? formatInTimeZone(timestamp, timeZone, "dd/MM/yyyy HH:mm") : "—";
};

export const whatsAppReportName = (name, id, fallback) => String(name || "").trim()
  || (id ? `${fallback} #${id}` : "—");

export const getWhatsAppReportMetric = (campaign, status) => {
  const value = campaign.delivery_summary?.[status]
    ?? (status === "pending" ? campaign.delivery_summary?.queued : undefined)
    ?? campaign.delivery_metrics?.[status] ?? campaign[`${status}_count`];
  if (value === null || value === undefined || value === "") return null;
  const count = Number(value);
  return Number.isSafeInteger(count) && count >= 0 ? count : null;
};
